import { Base } from '@studiometa/js-toolkit';

/**
 * Variant Selects
 */
export default class VariantSelects extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'VariantSelects',
    refs: ['disabledBtn[]'],
    emits: ['update-availability'],
  };

  /**
   * mounted
   */
  mounted() {
    this.updateOptions();
    this.productForm = document.querySelector('.main-add-to-cart form');
    [this.currentColor] = this.options;
  }

  /**
   * When changing variation
   * @returns {void}
   */
  onChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '');
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    this.$update();
  }

  /**
   * Open Restock popup
   * @returns {void}
   */
  onDisabledBtnClick() {
    if (document.querySelector('.restock-alerts-notify-button')) {
      setTimeout(() => {
        document.querySelector('.restock-alerts-notify-button').click();
      }, 200);
    }
  }

  /**
   * Update Options
   * @returns {void}
   */
  updateOptions() {
    this.options = Array.from(this.$el.querySelectorAll('select'), (select) => select.value);
  }

  /**
   * Update Master ID
   * @returns {void}
   */
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  /**
   * Update Gallery based on current variation
   * @returns {void}
   */
  async updateMedia() {
    if (!this.currentVariant) return;
    if (this.currentColor === this.options[0]) return;

    const productGallery = document.querySelector('.product-gallery-grid');

    productGallery.style.height = `${productGallery.offsetHeight}px`;
    [this.currentColor] = this.options;
    this.currentColor = this.currentColor.toLowerCase();
    const variantImages = document.querySelectorAll(`[data-group="${this.currentColor}"]`);
    if (variantImages.length === 0 && productGallery === undefined) {
      return;
    }

    productGallery.classList.add('opacity-0');

    setTimeout(() => {
      productGallery.innerHTML = '';
      variantImages.forEach((image) => {
        productGallery.innerHTML += image.innerHTML;
      });
      productGallery.classList.remove('opacity-0');
    }, 500);
  }

  /**
   * Update URL with variant selection
   * @returns {void}
   */
  updateURL() {
    if (!this.currentVariant || this.$el.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.$el.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  /**
   * Update Share Url
   * @returns {void}
   */
  updateShareUrl() {
    const shareButton = document.querySelector(`#Share-${this.$el.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.$el.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  /**
   * Update variant input
   * @returns {void}
   */
  updateVariantInput() {
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * Update variant statuses
   * @returns {void}
   */
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.$el.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.$el.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  /**
   * Set Input Availability
   * @param {Array} listOfOptions
   * @param {Array} listOfAvailableOptions
   */
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.textContent = input.getAttribute('value');
      } else {
        input.textContent = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'),
        );
      }
    });
  }

  /**
   * Update Pickup Availability
   * @returns {void}
   */
  updatePickupAvailability() {
    this.$emit('update-availability', this.currentVariant.id, this.currentVariant.available);
  }

  /**
   * Render Product Info
   * @returns {void}
   */
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.$el.dataset.originalSection
      ? this.$el.dataset.originalSection
      : this.$el.dataset.section;

    fetch(
      `${this.$el.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.$el.dataset.originalSection
          ? this.$el.dataset.originalSection
          : this.$el.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelector(`#price-${this.$el.dataset.section}`);
        const source = html.querySelector(
          `#price-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const variantsSource = html.querySelector(
          `#variant-radios-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const variantsDestination = document.querySelector(
          `#variant-radios-${this.$el.dataset.section}`,
        );

        const addToCartSource = html.querySelector('#main-add-to-cart');
        const addToCartDestination = document.querySelector('#main-add-to-cart');

        const stickyAddToCartSource = html.querySelector('#sticky-add-to-cart');
        const stickyAddToCartDestination = document.querySelector('#sticky-add-to-cart');

        const skuSource = html.querySelector(
          `#Sku-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );
        const skuDestination = document.querySelector(`#Sku-${this.$el.dataset.section}`);
        const inventorySource = html.querySelector(
          `#Inventory-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );
        const inventoryDestination = document.querySelector(
          `#Inventory-${this.$el.dataset.section}`,
        );

        const volumePricingSource = html.querySelector(
          `#Volume-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const pricePerItemDestination = document.querySelector(
          `#Price-Per-Item-${this.$el.dataset.section}`,
        );
        const pricePerItemSource = html.querySelector(
          `#Price-Per-Item-${
            this.$el.dataset.originalSection
              ? this.$el.dataset.originalSection
              : this.$el.dataset.section
          }`,
        );

        const volumePricingDestination = document.querySelector(
          `#Volume-${this.$el.dataset.section}`,
        );
        const qtyRules = document.querySelector(`#Quantity-Rules-${this.$el.dataset.section}`);
        const volumeNote = document.querySelector(`#Volume-Note-${this.$el.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            'hidden',
            pricePerItemSource.classList.contains('hidden'),
          );
        }

        if (variantsSource && variantsDestination) {
          variantsDestination.innerHTML = variantsSource.innerHTML;
          variantsDestination.classList.toggle(
            'hidden',
            variantsSource.classList.contains('hidden'),
          );
        }

        if (addToCartSource && addToCartDestination) {
          addToCartDestination.innerHTML = addToCartSource.innerHTML;
          addToCartDestination.classList.toggle(
            'hidden',
            addToCartSource.classList.contains('hidden'),
          );
        }

        if (stickyAddToCartSource && stickyAddToCartDestination) {
          stickyAddToCartDestination.innerHTML = stickyAddToCartSource.innerHTML;
          stickyAddToCartDestination.classList.toggle(
            'hidden',
            stickyAddToCartSource.classList.contains('hidden'),
          );
        }

        const price = document.querySelector(`#price-${this.$el.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.textContent === '');

        const addButtonUpdated = html.querySelector(`#ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );

        // eslint-disable-next-line no-undef
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        this.$parent.$update();
      });
  }

  /**
   * Toggle add Button
   * @param  {boolean} disable
   * @param  {string}  text
   * @returns {void}
   */
  toggleAddButton(disable = true, text = '') {
    const productForm = document.querySelector(`#product-form-${this.$el.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.dataset.ref = 'disabledBtn[]';
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('data-ref', 'disabledBtn[]');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  /**
   * Set Unvailable to btn
   */
  setUnavailable() {
    const button = document.querySelector(`#product-form-${this.$el.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.querySelector(`#price-${this.$el.dataset.section}`);
    const inventory = document.querySelector(`#Inventory-${this.$el.dataset.section}`);
    const sku = document.querySelector(`#Sku-${this.$el.dataset.section}`);
    const pricePerItem = document.querySelector(`#Price-Per-Item-${this.$el.dataset.section}`);
    const volumeNote = document.querySelector(`#Volume-Note-${this.$el.dataset.section}`);
    const volumeTable = document.querySelector(`#Volume-${this.$el.dataset.section}`);
    const qtyRules = document.querySelector(`#Quantity-Rules-${this.$el.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  /**
   * Get variant Data
   * @returns {Array}
   */
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.$el.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
